<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" :showBackButton="false" />
      </b-col>
    </b-row>

    <b-row class="mb-5">
      <b-col>
        <h2 class="purple bold">Tutoria - Sobre o aluno</h2>
      </b-col>
      <b-col class="text-right" style="padding-right: 32px">
        <b-button class="btn small blue" @click="() => $router.go(-1)"
          >Voltar</b-button
        >
      </b-col>
    </b-row>

    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="success" label="Carregando..."></b-spinner>
    </div>

    <b-row v-if="!loading && this.student !== null">
      <b-col cols="3" v-if="this.student">
        <b-avatar
          class="mb-4"
          :src="
            this.student && this.student.User && this.student.User.photo
              ? this.student.User.photo
              : '../../../assets/images/user_placeholder.png'
          "
          size="17rem"
        ></b-avatar>
        <div class="info-student">
          <h4>
            {{
              this.student.User.name && this.student.User
                ? this.student.User.name
                : "Não cadastrado"
            }}
          </h4>
          <ul>
            <li>
              <p
                v-if="student && student.Classroom && student.Classroom.year_id"
              >
                {{
                  this.student.Cycle && this.student.Cycle.name
                    ? this.student.Cycle.designation
                    : ""
                }}
                <br />
                ({{ this.student.year_id }}º ano no ciclo)
              </p>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col>
        <b-tabs class="tab-content" content-class="mt-5">
          <b-tab
            title="Entrevista Inicial"
            v-if="showInitialInterviewTab || showButtons"
          >
            <InitialInterviewTab
              v-if="student && student.id"
              :studentId="student.id"
            />
          </b-tab>
          <b-tab title="Frequência" @update:active="onAttendanceTabActive">
            <StudentAttendanceReport
              v-if="attendanceTabOpened && student && student.id"
              :studentId="student.id"
              embedded
            />
          </b-tab>
          <b-tab
            title="Documentos e Atas"
            v-if="showDocumentsTab"
            @update:active="onDocumentsTabActive"
          >
            <StudentDocumentsComponent
              v-if="documentsTabOpened && student && student.id"
              :studentId="student.id"
              :canManage="false"
            />
          </b-tab>
          <b-tab title="Pareceres" v-if="showStatementsTab">
            <StatementsComponent
              :studentId="student.id"
              :currentUserId="currentUserId"
              :showButton="showButtons"
            />
          </b-tab>
          <b-tab title="Tutoria">
            <b-row class="mb-5" align-v="center">
              <b-col class="">
                <h4>Observações de tutoria</h4>
              </b-col>
              <b-col cols="4" v-if="showButtons">
                <b-button class="btn large blue" @click="openCreateModal()">
                  <b-icon icon="plus" aria-hidden="true"></b-icon>Registrar
                  observação
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col>
                <ul class="tutoring-list" v-if="remarks.length > 0">
                  <li v-for="(item, index) in remarks" :key="index">
                    <i>
                      <strong>{{
                        item.teacher == teacher_id
                          ? "Por mim"
                          : item.teacherName
                      }}</strong>
                      <time> • {{ item.created_at }} </time>

                      <time v-if="item.period_report_id && item.PeriodReport">
                        • Comentário
                        <strong>{{
                          item.PeriodReport.status === "approved"
                            ? "aprovado"
                            : "com aprovação pendente"
                        }}</strong>
                        no informe periódico do
                        {{ item.PeriodReport.Period.name }}
                      </time>
                    </i>

                    <p style="white-space: pre-line">
                      {{ item.remarks }}
                    </p>
                    <div class="files-container" v-if="item.file_url !== null">
                      <div class="file-item">
                        <a
                          :href="`${item.file_url}`"
                          target="_blank"
                          class="file-link"
                        >
                          <b-icon
                            icon="file-arrow-down"
                            aria-hidden="true"
                          ></b-icon>
                          <span>{{ item.file_name }}</span>
                        </a>
                      </div>
                    </div>
                    <b-button-group
                      size="sm"
                      class="btn-group"
                      v-if="item.teacher == teacher_id"
                    >
                      <button
                        class="btn large blue"
                        @click="getSingleRemark(item.id)"
                        v-if="
                          !item.period_report_id ||
                          (item.period_report_id &&
                            item.PeriodReport &&
                            item.PeriodReport.status !== 'approved')
                        "
                      >
                        Editar
                      </button>
                      <button @click="deleteRemark(item.id)">Excluir</button>
                    </b-button-group>
                  </li>
                </ul>
                <b-row class="box-not-found" v-else>
                  <ul class="message-not-found">
                    <li>
                      <p>Ainda não existe observação para esse aluno.</p>
                    </li>
                  </ul>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="RDA" active>
            <StudentRDAComponent :studentId="student.id" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>

    <pendency-modal
      modal-id="modal-detail-evidence"
      :content="pendencyText"
      @close="onModalClose"
    />

    <b-modal id="modal-register" hide-footer>
      <template #modal-title>Novo Registro</template>
      <div class="d-block text-center">
        <b-form>
          <b-form-group
            id="modal-form-observation"
            label="Observação"
            label-for="form-observation"
          >
            <b-form-textarea
              id="form-observation"
              v-model="form.remarks"
              type="textarea"
              placeholder=""
              required
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <div class="info-message mb-3">
              <b-icon icon="info-circle" aria-hidden="true"></b-icon>
              <span
                >Os comentários de tutoria sempre ficam visíveis para as
                famílias.</span
              >
            </div>
            <label class="box-ckeckbox" for="form-checked-student">
              <span>Visível para o estudante</span>
              <b-form-checkbox
                id="form-checked-student"
                v-model="form.student_view"
                name="form-checked-student"
                switch
              ></b-form-checkbox>
            </label>
            <label class="box-ckeckbox" for="form-checked-period_report">
              <span>Mostrar no informe periódico</span>
              <b-form-checkbox
                id="form-checked-period_report"
                v-model="form.is_for_period_report"
                name="form-checked-period_report"
                switch
              ></b-form-checkbox>
            </label>
          </b-form-group>
          <b-form-group v-if="!form.is_for_period_report">
            <UploadFiles v-model="form.files" />
          </b-form-group>
          <b-form-group class="wrap-btn-form">
            <b-button
              :disabled="submiting"
              class="btn middle blue"
              @click="createRemark"
            >
              {{ submiting ? "Aguarde..." : "Registrar" }}
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>

    <b-modal id="modal-update" hide-footer>
      <template #modal-title>Atualizar Registro</template>
      <div class="d-block text-center">
        <b-form>
          <b-form-group
            id="modal-form-observation"
            label="Observação"
            label-for="form-observation"
          >
            <b-form-textarea
              id="form-observation"
              v-model="form.remarks"
              type="textarea"
              placeholder=""
              required
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <div class="info-message mb-3">
              <b-icon
                :icon="
                  form.parent_view ? 'info-circle' : 'exclamation-triangle-fill'
                "
                aria-hidden="true"
              ></b-icon>
              <span v-if="form.parent_view"
                >Os comentários de tutoria sempre ficam visíveis para os
                responsáveis.</span
              >
              <span v-else
                >Os comentários de tutoria ficam visíveis para os responsáveis;
                no entanto, esta observação específica está OCULTA para
                eles.</span
              >
            </div>
            <label class="box-ckeckbox" for="form-checked-student">
              <span>Visível para o estudante</span>
              <b-form-checkbox
                id="form-checked-student"
                v-model="form.student_view"
                name="form-checked-student"
                switch
              ></b-form-checkbox>
            </label>
            <label class="box-ckeckbox" for="form-checked-period_report">
              <span>Mostrar no informe periódico</span>
              <b-form-checkbox
                id="form-checked-period_report"
                v-model="form.is_for_period_report"
                name="form-checked-period_report"
                switch
              ></b-form-checkbox>
            </label>
          </b-form-group>
          <b-form-group v-if="!form.is_for_period_report">
            <UploadFiles v-model="form.files" :fileName="files" />
          </b-form-group>
          <b-form-group class="wrap-btn-form">
            <b-button
              :disabled="submiting"
              class="btn middle blue"
              @click="updateRemark(formId)"
            >
              {{ submiting ? "Aguarde..." : "Atualizar" }}
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import InitialInterviewTab from "@/components/InitialInterviewTab.vue";
import UploadFiles from "@/components/inputs/UploadFiles.vue";
import PendencyModal from "@/components/PendencyModal.vue";
import StatementsComponent from "@/components/StatementsComponent.vue";
import StudentDocumentsComponent from "@/components/StudentDocumentsComponent.vue";
import StudentAttendanceReport from "@/components/StudentAttendanceReport.vue";
import StudentRDAComponent from "@/components/StudentRDAComponent.vue";
import DataService from "@/services/cycles.service";
import moment from "moment";
import httpRda from "../../../http-rda";
import store from "../../../store";

export default {
  name: "tutotia-aluno",
  components: {
    UploadFiles,
    StudentRDAComponent,
    PendencyModal,
    StatementsComponent,
    StudentDocumentsComponent,
    InitialInterviewTab,
    StudentAttendanceReport,
  },

  data() {
    return {
      isTeacher: false,
      showStatementsTab: true,
      showInitialInterviewTab: false,
      showDocumentsTab: false,
      pendencyText: null,
      breadcrumb: [
        {
          text: "Tutoria",
          href: "/comunidade/tutoria",
        },
        {
          text: "Tutoria - Sobre o aluno",
          href: null,
        },
      ],

      apenas: true,
      loading: false,
      remarks: [],
      student: null,
      tutor: null,
      teacher_id: null,
      showButtons: true,
      submiting: false,
      form: {
        remarks: null,
        parent_view: null,
        student_view: false,
        is_for_period_report: false,
        files: [],
      },
      formId: Number,
      reportModalMode: null,
      currentUserId: null,
      files: null,
      attendanceTabOpened: false,
      documentsTabOpened: false,
    };
  },

  methods: {
    openCreateModal() {
      this.reportModalMode = "Novo";
      this.formId = null;
      this.form.remarks = null;
      this.form.student_view = false;
      this.form.is_for_period_report = false;
      this.files = null;

      this.$swal
        .fire({
          title: "Informação importante",
          html: "Os comentários da aba de tutoria sempre ficarão <strong>visíveis para as famílias</strong>.<br><br>As observações internas devem ser feitas na aba de <strong>PARECERES</strong>.",
          icon: "info",
          confirmButtonText: "Entendi",
          confirmButtonColor: "#68c5b7",
        })
        .then(() => {
          this.$bvModal.show("modal-register");
        });
    },

    onModalClose() {
      this.pendencyText = null;
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY [às] HH:mm");
    },

    async getAllTutoringData(student_id) {
      this.loadingRDA = true;
      const response = await httpRda.get(
        `/tutoring/student/${student_id}/tutoringData`
      );

      this.tutoringData = response.data.tutoringData;
      this.remarks = this.tutoringData.remarkTutoring.map((remark) => {
        return {
          ...remark,
          created_at: moment(remark?.created_at).format(
            "DD/MM/YYYY [às] hh:mm"
          ),
          updated_at: moment(remark?.updated_at).format(
            "DD/MM/YYYY [às] hh:mm"
          ),
        };
      });

      this.loadingRDA = false;
    },

    async getDataUser(showLoadingOverlay = true) {
      if (showLoadingOverlay) {
        this.loading = true;
      }
      const { id } = this.$route.params;

      if (!id) {
        this.$router.push("/comunidade/tutoria");
      } else {
        const user = store.getters["auth/getAuthData"];
        const { teacher_id } = user;
        this.teacher_id = teacher_id;

        await httpRda
          .get(`students?include=parents,cycle,classroom&user_id=${id}`)
          .then(async (res) => {
            this.student = res.data.students[0];

            if (!this.teacher_id) {
              this.showButtons = false;
            } else {
              await httpRda
                .get(`/tutoring/student/${this.student.id}/tutor`)
                .then((response) => {
                  const result = response.data;
                  if (result.tutor && result.tutor.teacher_id) {
                    result.tutor.teacher_id === this.teacher_id
                      ? (this.showButtons = true)
                      : (this.showButtons = false);
                  } else {
                    this.showButtons = false;
                  }
                });
            }
            await this.getAllTutoringData(this.student.id);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    async createRemark() {
      this.submiting = true;
      if (this.form.remarks == null) {
        this.$swal.fire({
          title: "Alerta",
          text: "Preencher a observação",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        try {
          const formData = new FormData();
          formData.append("remarks", this.form.remarks);
          formData.append("student_view", this.form.student_view);
          formData.append(
            "is_for_period_report",
            this.form.is_for_period_report
          );
          formData.append("user_id", this.student.id);
          formData.append("teacher", this.teacher_id);
          formData.append("file", this.form.files);

          await httpRda.post(`/remarks`, formData);
          this.submiting = false;
          this.$swal.fire({
            title: "Sucesso",
            text: "Observação registrada com sucesso.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.form.remarks = null;
          this.$bvModal.hide("modal-register");
          await this.getDataUser(false);
        } catch (err) {
          this.submiting = false;
          this.$swal.fire({
            title: "Alerta",
            text: err.message,
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        this.form.files = null;
        this.submiting = false;
      }
    },

    async deleteRemark(id) {
      this.$swal
        .fire({
          title: "Tem certeza?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await httpRda.delete(`/remarks/${id}`).then(() => {
                this.$swal.fire({
                  icon: "success",
                  title: "Excluído",
                  text: "Observação excluída com sucesso.",
                });
              });

              await this.getDataUser(false);
            } catch (err) {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  err?.response?.data?.message || "Não foi possivel excluir!",
                footer: "Por favor, tente novamente mais tarde.",
              });
              await this.getDataUser(false);
              return err;
            }
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: err.message,
            text: "Não foi possivel excluir!",
          });
        });
    },

    async getSingleRemark(id) {
      const remarkData = await httpRda
        .get(`/remarks/${id}`)
        .then((e) => e.data.remark);
      this.formId = id;
      this.form.remarks = remarkData.remarks;
      this.form.parent_view = remarkData.parent_view;
      this.form.student_view = remarkData.student_view;
      this.form.is_for_period_report = remarkData.period_report_id
        ? true
        : false;
      this.files = remarkData.file_name;
      this.$bvModal.show("modal-update");
    },

    async updateRemark(id) {
      this.submiting = true;
      try {
        const formData = new FormData();
        formData.append("remarks", this.form.remarks);
        formData.append("student_view", this.form.student_view);
        formData.append("is_for_period_report", this.form.is_for_period_report);
        formData.append("user_id", this.student.id);
        formData.append("teacher", this.teacher_id);
        formData.append("file", this.form.files);

        await httpRda.patch(`/remarks/${id}`, formData);
        this.submiting = false;
        this.$swal.fire({
          title: "Sucesso",
          text: "Observação atualizada com sucesso.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        this.form.remarks = null;
        this.$bvModal.hide("modal-update");
        await this.getDataUser(false);
      } catch (err) {
        this.submiting = false;
        this.$swal.fire({
          title: "Alerta",
          text: err?.response?.data?.message || err.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
      this.form.files = null;
      this.submiting = false;
    },

    onAttendanceTabActive(active) {
      if (active) {
        this.attendanceTabOpened = true;
      }
    },

    onDocumentsTabActive(active) {
      if (active) {
        this.documentsTabOpened = true;
      }
    },

    canEditStatement(statement) {
      return (
        statement.teacher_id === this.currentUserId ||
        statement.user_id === this.currentUserId ||
        statement.created_by === this.currentUserId
      );
    },

    async getCurrentUser() {
      this.currentUserId = store.getters["auth/getAuthData"];
      const cycles = await DataService.getAll({});
      const teacherCycles =
        cycles?.data?.cycles?.map((cycle) => cycle.id) || [];
      const roles = this.currentUserId.role;
      const isTeacher =
        roles.includes("teacher") &&
        teacherCycles.some((cycleId) => cycleId === this?.student?.Cycle?.id);
      const isStudentOrParent =
        roles.includes("student") || roles.includes("parent");

      this.showStatementsTab = isTeacher || !isStudentOrParent;

      this.showDocumentsTab = [
        "admin",
        "coordinator",
        "teacher",
        "psychologist",
        "specialized_educational_support",
      ].some((role) => roles.includes(role));

      this.showInitialInterviewTab =
        this.currentUserId.role.includes("admin") ||
        this.currentUserId.role.includes("coordinator") ||
        this.currentUserId.role.includes("psychologist") ||
        this.currentUserId.role.includes("secretary") ||
        this.currentUserId.role.includes("specialized_educational_support");

      this.currentUserId = this.currentUserId.id;
    },
  },

  async created() {
    await this.getDataUser();
    await this.getCurrentUser();
    this.loading = false;
  },

  mounted() {},
};
</script>

<style lang="scss">
.evidence-btn {
  border-radius: 5px;
  background-color: #68c5b7;
  color: white;
  border: none;
}

$artes-visuais: #b2ecf7;
$lingua-estrangeira: #ffc2c2;
$ciencias-da-natureza: #d1e7c0;
$ciencias-humanas: #d8c7ee;
$corpo-e-mente: #ffd97d;
$danca: #ff8b94;
$historia: #ffd9b6;
$lingua-portuguesa: #b2c9f7;
$matematica: #ffc9ed;
$espanhol: #a3e0ce;
$musica: #ffad76;
$cidadania-vida: #e7b3c8;
$teatro: #aedbad;
$ingles: #90a8e6;

.info-student {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  row-gap: 16px;

  ul {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    row-gap: 10px;
    margin: 0;
    padding: 0;

    li {
      list-style: none;

      b {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
      }

      p {
        font-size: 18px;
        color: #000;
        margin-bottom: 0;
      }
    }
  }
}

.tab-content {
  .nav-tabs {
    border-bottom: 2px solid #e6e6e6;
    gap: 24px;

    li {
      &:first-child {
        a {
          text-align: left;
          padding: 0;
        }
      }
    }

    .nav-link {
      text-align: center;
      font-size: 18px;
      color: #1a1a1a;
      height: 52px;
      border: 0;
      padding: 0 18px;
      position: relative;

      &.active {
        font-weight: bold;
        background: transparent;

        &:after {
          width: 100%;
        }
      }

      &:after {
        background: $gradient1;
        content: "";
        width: 0;
        height: 4px;
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 50px;
        transition: 0.2s all ease-in-out;
      }
    }
  }
}

.box-not-found {
  display: flex;
  flex-direction: row;
  justify-content: center;
  widows: 100%;
}

.message-not-found {
  width: 100%;
  background: $white;
  border: 1px solid #ededed;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  box-sizing: border-box;
  list-style: none;
  margin-bottom: 20px;

  p {
    margin: 0;
    color: #666666;
    font-size: 16px;
  }

  .btn {
    margin: 0 auto;
  }
}

.btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 5px;

  svg {
    font-size: 175% !important;
  }
}

.tutoring-list {
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    border-bottom: 2px solid #e6e6e6;
    padding-bottom: 32px;
    list-style: none;

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }

    i {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      font-style: normal;
      font-size: 14px;
      color: #666666;
      margin-bottom: 8px;

      strong {
        color: #333;
        font-weight: 600;
      }

      time {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
    }

    p {
      margin-bottom: 0;

      &.professional-info {
        font-size: 14px;
        color: #666666;
        margin-top: 4px;

        strong {
          font-weight: 600;
        }
      }
    }

    .files-container {
      display: flex;
      gap: 8px;
      margin-top: 12px;
      margin-bottom: 12px;

      .file-item {
        .file-link {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 12px;
          background: #fff;
          border: 1px solid #e9e9e9;
          border-radius: 6px;
          text-decoration: none;
          color: #333;
          cursor: pointer;
          transition: 0.2s all ease-in-out;

          &:hover {
            box-shadow: 3px 3px 0 rgba(0, 0, 0, 0.1);
            transform: translate(-3px, -3px);
          }

          span {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            max-width: 200px;
          }
        }
      }
    }

    .btn-group {
      gap: 10px;
      padding-top: 10px;

      button {
        font-weight: 600;
        font-size: 16px;
        color: $purple;
        background-color: transparent;
        border: 0;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

#modal-register {
  .modal-dialog {
    max-width: 700px;
  }

  .modal-header {
    border: 0;
    position: relative;

    h5 {
      font-size: 24px;
    }

    .close {
      font-size: 16px;
      color: #fff;
      background: #b3b3b3;
      width: 24px;
      height: 24px;
      border-radius: 50px;
      padding: 0;
      position: absolute;
      top: 32px;
      right: 32px;
    }
  }
}

#modal-create-statement,
#modal-edit-statement {
  .modal-dialog {
    max-width: 700px;
  }

  .modal-header {
    border: 0;
    position: relative;

    h5 {
      font-size: 24px;
    }

    .close {
      font-size: 16px;
      color: #fff;
      background: #b3b3b3;
      width: 24px;
      height: 24px;
      border-radius: 50px;
      padding: 0;
      position: absolute;
      top: 32px;
      right: 32px;
    }
  }
}

form {
  text-align: left;

  .info-message {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background-color: #e8f4f8;
    border-left: 4px solid #68c5b7;
    border-radius: 4px;
    color: #333;
    font-size: 14px;

    svg {
      color: #68c5b7;
      flex-shrink: 0;
    }

    span {
      line-height: 1.4;
    }
  }

  .box-ckeckbox {
    background: #ffffff;
    height: 58px;
    border: 1px solid #b3b3b3;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.375rem 0.75rem;
    box-sizing: border-box;
    cursor: pointer;

    .custom-control-input:checked ~ .custom-control-label {
      &::before {
        background: $purple;
      }

      &::after {
        background: $white;
        left: -35px !important;
        opacity: 1;
      }
    }

    .custom-switch {
      .custom-control-label {
        &::before {
          background: transparent;
          width: 59px;
          height: 26px;
          border-color: $purple;
          border-radius: 100px;
          left: -3.75rem;
        }

        &::after {
          background: $purple;
          width: 18px;
          height: 18px;
          top: 8px;
          left: -54px;
          opacity: 0.5;
        }
      }
    }
  }
}

.wrap-btn-form {
  width: 100%;
  border-bottom: 1px solid #b3b3b3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 0;
  margin-bottom: 24px;
  box-sizing: border-box;

  button {
    width: 146px;
  }
}

.informative {
  text-align: left;

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: #666666;
    margin-bottom: 10px;
  }
}

.rda-tabs {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 40px;

  .tab {
    background: linear-gradient(180deg, #fff -16%, #fff 113%);
    flex: 0 0 270px;
    height: 94px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8;
    transition: 0.2s all;
    cursor: pointer;

    &:hover {
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    }

    &.active {
      background: linear-gradient(180deg, #ef6549 -16%, #b23066 113%);

      b,
      span {
        color: #fff;
      }
    }

    b {
      font-size: 16px;
      color: #666666;
    }

    span {
      font-size: 14px;
      color: #666666;
    }
  }
}

.rda-tab-content {
  padding-left: 0;

  &:last-child {
    .progress-rda {
      .lines {
        height: 100%;
        top: 0;
      }
    }
  }
}

.progress-rda {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  overflow: visible !important;

  &:after {
    content: "";
    background: #f2f2f2;
    width: 100%;
    height: 80px;
    border-radius: 0 10px 10px 0;
    position: absolute;
    top: 0;
    left: 0px;
    z-index: 0;
  }

  p {
    font-size: 18px;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
    z-index: 2;
  }

  .bar {
    background: #d8c7ee;
    height: 100%;
    border-radius: 0 10px 10px 0;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    &.artes-visuais {
      background: $artes-visuais;
    }

    &.lingua-estrangeira {
      background: $lingua-estrangeira;
    }

    &.ciencias-da-natureza {
      background: $ciencias-da-natureza;
    }

    &.ciencias-humanas {
      background: $ciencias-humanas;
    }

    &.corpo-e-mente {
      background: $corpo-e-mente;
    }

    &.danca {
      background: $danca;
    }

    &.historia {
      background: $historia;
    }

    &.lingua-portuguesa {
      background: $lingua-portuguesa;
    }

    &.matematica {
      background: $matematica;
    }

    &.espanhol {
      background: $espanhol;
    }

    &.musica {
      background: $musica;
    }

    &.cidadania-vida {
      background: $cidadania-vida;
    }

    &.teatro {
      background: $teatro;
    }

    &.ingles {
      background: $ingles;
    }
  }

  .lines {
    width: 1px;
    height: 116%;
    display: block;
    border-left: 1px dashed #b3b3b3;
    position: relative;
    top: 6px;
    z-index: 2;
  }
}

.viewButton {
  background: transparent;
  border: 0;

  svg {
    width: 20px;
  }
}

.tags {
  &.warning {
    background-color: var(--orange);
  }
}

.back-rda {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 40px;
  cursor: pointer;

  svg {
    transform: rotate(180deg);
    height: 18px;
  }

  span {
    font-size: 18px;
    font-weight: bold;
    color: #4f4f4f;
    position: relative;
    top: 2px;
  }
}

.title-viewRDA {
  background: linear-gradient(270deg, #6883c5 0%, #36b67d 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  margin-bottom: 40px;

  b {
    color: #fff;
    font-weight: bold;
  }

  span {
    color: #fff;
  }
}

.rda-viewlist {
  margin-bottom: 30px;

  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #36b67d;
    margin-bottom: 12px;
  }

  .item-rda-viewlist {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    .cols {
      .tags {
        min-width: 40px;
      }
    }

    .text-col {
      flex: 1;
    }
  }
}

.activePeriodEmpty {
  border: dashed #d1c8c8 0.5px !important;
  background-color: #fafafa !important;
}

.title-view-rda {
  font-size: 22px;
}

.competence-details {
  color: #b23066;
  font-weight: 700;
}

.tematic-unit-title {
  color: #36b67d;
  font-weight: 600;
  font-size: 18px;
}

.comp-description {
  padding-right: 40px !important;
  font-size: 16px !important;
  line-height: 20px;
}

.knowledge-object-title {
  font-weight: 600;
  font-size: 16px;
}

.topic-description {
  font-size: 14px;
  line-height: 18px;
}

.existing-files {
  margin-bottom: 15px;

  label {
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    display: block;
  }

  .current-files-list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .current-file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px;
      background-color: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 6px;

      .file-name {
        font-size: 14px;
        color: #495057;
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .btn-remove-file {
        background: none;
        border: none;
        color: #dc3545;
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;

        &:hover {
          color: #c82333;
        }
      }
    }
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>
